
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.2 94.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"47.1","fill":"#cad3e0"}}),_c('path',{attrs:{"d":"M22.8 37.3c.1-.1.3-.1.4-.1-.3-.1-.5-.1-.8-.1h-5.1c-1.8 0-3.3 1.4-3.3 3.2s1.5 3.2 3.3 3.2h1c.7-2.6 2-5.3 4.5-6.2z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"59.6","cy":"28.2","r":"9.9","fill":"#fff"}}),_c('circle',{attrs:{"cx":"34.7","cy":"30.4","r":"9.9","fill":"#fff"}}),_c('path',{attrs:{"d":"M46.9 37.4c3.5 1.3 4.6 6.1 5.3 9.2 0 0 1.7 7.7 2.5 16.3.6-.1 1.1-.1 1.7 0 6.8 1.4 13.6-2.2 15.3-8.1 1.2-4.3-.6-9.4-4.6-12.7-1.5-1.2-2-3.2-1.4-4.9-1.4.9-3.4 1.8-5.9 1.8h-.3c-4.1-.1-6.9-2.4-7.9-3.5-.3-.3-.7-.5-1.1-.5-.6 0-1.3.1-2.1.4-.9.4-1.7 1-2.3 1.8.3 0 .6.1.8.2zm12.6 34.8c-1.4 0-2.9-.1-4.3-.4v1.1h24c.2-3.6-.1-7.7-.4-11.6C75 68 67.6 72.2 59.5 72.2z","fill":"#fff"}}),_c('path',{attrs:{"d":"M54.3 70.5c-1.6-.6-2.5-2.3-2.2-4 .4-1.9 2.3-3.1 4.1-2.7 7.3 1.5 14.6-2.5 16.5-8.8 1.3-4.7-.6-10.2-4.9-13.7a3.49 3.49 0 014.4-5.4c6.5 5.3 9.3 13.6 7.2 21.1-2.8 10-13.7 16-24.6 13.8-.1-.2-.3-.2-.5-.3z","fill":"#fff"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M54.2 69.3c0-1.3-.1-2.6-.2-4-.4.3-.7.8-.9 1.4-.2 1 .2 2 1.1 2.6z"}}),_c('path',{attrs:{"d":"M53.9 71.4c-2-.8-3.2-2.9-2.8-5.1.3-1.5 1.3-2.7 2.6-3.2-.8-8.5-2.6-16.4-2.6-16.4-.7-2.9-1.8-7.6-5.3-8.8-.8-.3-1.5-.3-2.1-.3-.4 0-.8.2-1.1.5-1.1 1-3.8 3.2-7.9 3.2h-.3c-4.1-.1-6.9-2.2-7.9-3.2-.3-.3-.7-.4-1.1-.5-.5 0-1.1 0-1.7.2-.1 0-.3.1-.4.1-2.5.9-3.8 3.6-4.6 6.1-.3 1-.5 1.9-.7 2.8 0 0-3.4 15.2-2.9 26.2h38.8v-1.4c.2-.1.1-.1 0-.2z"}})])])
          )
        }
      }
    